import {Observable} from "rxjs";
import {NotificationOpenedResult} from "./model/notification-opened-result";
import {PushNotificationsRepository} from "./repository/push-notifications-repository";
import {DeviceDAO} from "../data/device.dao";
import {DeviceWS} from "../data/device.ws";


export abstract class PushNotificationsService {
  abstract initWithRepository(appId:string, pushNotificationsRepository: PushNotificationsRepository): void;

  abstract init(appId: string, deviceDAO: DeviceDAO, deviceWS: DeviceWS): void;

  abstract get onNotificationOpen$(): Observable<NotificationOpenedResult>;

  abstract get onSubscriptionChange$(): Observable<string | undefined>;

  abstract requestPermissions(): Observable<boolean>;

  abstract enableNotifications(): void

  abstract disableNotifications(): void
}
